import { AbstractQuery } from 'src/models/query';

export const createGetTheSessionIdFromTheAccessTokenQuery = (jwtToken: string): AbstractQuery => {
	class GetTheSessionIdFromTheAccessToken extends AbstractQuery {
		name = 'IFS_Authentication_Query_Queries_GetTheSessionIdFromTheAccessTokenQuery';
		sort = [];

		constructor() {
			super();
			this.parameters.push({ jwtToken });
		}
	}

	return new GetTheSessionIdFromTheAccessToken();
};
